export default __webpack_public_path__ + "static/media/x-icon.7df2f9e7.svg";